import { render } from "./DefaultAdjustmentsTable.vue?vue&type=template&id=0a0ad9d2&scoped=true"
import script from "./DefaultAdjustmentsTable.vue?vue&type=script&lang=js"
export * from "./DefaultAdjustmentsTable.vue?vue&type=script&lang=js"

import "./DefaultAdjustmentsTable.vue?vue&type=style&index=0&id=0a0ad9d2&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0ad9d2"]])

export default __exports__